// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const RequestQuote: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 9">
            <path
                fill="currentColor"
                d="M13.5 0H0v9h13.5V0ZM12 3v.75H6V3h6ZM6 5.25h6V6H6v-.75Zm-2.154-3v.148c.155.028.39.075.492.103l.453.12-.242.906-.452-.12a7.81 7.81 0 0 0-.509-.1c-.286-.045-.52-.007-.67.061-.148.068-.185.145-.192.19-.014.08 0 .11.002.117.007.012.024.042.084.082.143.098.368.169.701.267l.019.005c.284.087.663.2.947.408.157.115.305.267.396.48.094.213.113.448.07.69-.077.445-.372.75-.74.906-.115.05-.235.085-.361.108v.6h-.94V6.6a8.017 8.017 0 0 1-.802-.248l-.445-.148.295-.89.446.147.15.05c.222.074.473.16.614.184.3.047.532.017.675-.044.129-.054.173-.124.187-.206.017-.094.003-.139-.004-.157a.254.254 0 0 0-.087-.094c-.138-.101-.359-.176-.687-.274l-.051-.017c-.275-.082-.633-.19-.905-.375a1.142 1.142 0 0 1-.406-.457 1.119 1.119 0 0 1-.08-.68c.076-.429.38-.724.73-.883.117-.054.241-.094.372-.12v-.61h.942v.472h-.002Z"
                opacity=".5"
            />
        </svg>
    );
};

export default React.memo(RequestQuote);
